import React, { forwardRef, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Portal from '@mui/material/Portal';
import PropTypes from 'prop-types';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

const SnackbarInfo = ({ type, message }) => {
  const [open, setOpen] = useState(true);

  const handleAutoClose = () => {
    setOpen(false);
  };

  return (
    <Portal>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={5000}
        onClose={handleAutoClose}
      >
        <Alert severity={type} onClose={handleAutoClose}>
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

SnackbarInfo.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default SnackbarInfo;
